import { render, staticRenderFns } from "./TabbedPortletOpportunity.vue?vue&type=template&id=4c2904aa&"
import script from "./TabbedPortletOpportunity.vue?vue&type=script&lang=js&"
export * from "./TabbedPortletOpportunity.vue?vue&type=script&lang=js&"
import style0 from "./TabbedPortletOpportunity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports